export const isConfig = (thing) => typeof thing === 'object' &&
    typeof thing.supportClientId === 'string' &&
    !!thing.supportClientId &&
    typeof thing.supportCognitoBaseUrl === 'string' &&
    !!thing.supportCognitoBaseUrl;
export const validateConfig = (thing) => {
    if (isConfig(thing)) {
        return thing;
    }
    throw new Error(`Invalid Config: ${JSON.stringify(thing)}`);
};
//# sourceMappingURL=config.js.map